// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Init, NexusContainer } from '@return-rabbit/nexus';

import { FlexColumn, Gap } from 'ui-components/components/flex';

import style from './style.module.less';

export const ChooseItemsStepBody = () => {
  return (
    <NexusContainer>
      <FlexColumn className={style.layout} gap={Gap.Space32}>
        <Init.ServiceableItems />
        <Init.NotServiceableItems />
        <Init.AlreadyServicedItems isNameDisplay />
      </FlexColumn>
    </NexusContainer>
  );
};
